import React from "react";
import {
  FieldError,
  FieldErrorsImpl,
  Merge,
  RegisterOptions,
} from "react-hook-form";
import { UseFormRegister } from "react-hook-form";
import { FormattedMessage, useIntl } from "@/i18n/i18n-client";
import FormField from "../FormField";

interface NameInputFieldProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  register: UseFormRegister<any>;
  error: FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined;
  fieldName?: string;
  registerOptions?: RegisterOptions;
  label?: React.ReactNode;
}

const specialCharRegex = /[0-9٠-٩!@#$%^&*()_+\-=[\]{};:"\\|,.<>/?]/;

const NameInputField = ({
  register,
  error,
  fieldName = "name",
  label = <FormattedMessage defaultMessage="Name" id="HAlOn1" />,
  ...props
}: NameInputFieldProps) => {
  const intl = useIntl();

  return (
    <FormField label={label} id={fieldName} error={error}>
      <input
        {...register(fieldName, {
          ...props.registerOptions,
          validate: (value, formValues) => {
            const trimmedValue = value?.trim();
            if (trimmedValue?.length < 3 && trimmedValue?.length > 0) {
              return intl.formatMessage({
                defaultMessage: "Name must be at least 3 characters long",
                id: "bFlWF8",
              });
            }
            if (specialCharRegex.test(trimmedValue)) {
              return intl.formatMessage({
                defaultMessage: "Name must contain only letters",
                id: "tHoMCI",
              });
            }
            if (props.registerOptions?.validate) {
              const validateFn = props.registerOptions.validate;
              if (typeof validateFn === "function") {
                return validateFn(value, formValues);
              }
            }
            return true;
          },
        })}
        {...props}
        id={fieldName}
        className={`field-input ${error ? "invalid" : ""} ${props.className}`}
        placeholder={
          props.placeholder ||
          intl.formatMessage({
            defaultMessage: "Enter your name",
            id: "DX9QSt",
          })
        }
      />
    </FormField>
  );
};

export default NameInputField;
